
// TODO add loading indicator
// TODO add magnifying glass icon
// TODO prettier hide/show. Use hide-class instead.
// TODO setup search in /butikker

let _search = (() => {
    return () => {

        let hideOnClickOutside = require('../../global/util').hideOnClickOutside;

        let _elements = {},
            _listModifier = '',
            _noMatchMessage;

        let _cacheDOM = ($container) => {
            _elements.$container = $container;
            _elements.$input = $container.find('.search__input');
            _elements.$results = $container.find('.search__item-list');
        };

        let _cacheData = () => {
            _listModifier = _elements.$container.data('list-modifier');
            _noMatchMessage = _elements.$container.data('no-match');
        };

        let _bindEvents = () => {
            _elements.$input.on('input', function (e) {
                let value = this.value;

                if (value !== '') {
                    window.apiService.searchStores(value).done(function (res) {

                        // Cancel if user has deleted query during ajax call
                        if (_elements.$input.val() === '') {
                            _emptyAndHideResultList();
                            return;
                        }

                        // Show user feedback if query has no search hits
                        if (res.data.length === 0) {
                            _showEmptyStoreListMessage();
                            _showStoreList();
                            return;
                        }

                        _updateStoreList(res.data);
                    })
                } else {
                    _emptyAndHideResultList();
                }

            });

        };

        let _showEmptyStoreListMessage = () => {
            _elements.$results.html(
                '<div class="search__list-item search__list-item--message">' +
                    '<span class="search__item-title search__item-title--message">' + _noMatchMessage + '</span>' +
                '</div>'
            );
        };

        let _updateStoreList = (stores) => {
            // First remove old stores
            _elements.$results.html('');

            // Add new stores to list
            stores.map(function (store) {
                _elements.$results.append(_storeListItem(store.logo_url, store.title, store.url));
            });

            // Show the list
            _showStoreList();
        };

        let _showStoreList = () => {
            _elements.$results.show();
            hideOnClickOutside(_listModifier);
        };

        let _emptyAndHideResultList = () => {
            _elements.$results.hide();
            _elements.$results.html('');
        };

        let _storeListItem = function(logo, title, url) {
            let image = logo
                ? '<img src="' + logo + '" class="search__item-logo" alt="' + title + ' rabattkode">'
                : '<div class="search__item-logo search__item-logo--hidden"></div>';

            return (
                '<a href="' + url + '" class="search__list-item">' +
                    image +
                    '<span class="search__item-title">' + title + '</span>' +
                '</a>'
            );
        };

        let _focusSearchField = () => _elements.$input.focus();

        let _clear = () => {
            _elements.$input.val = '';
            _emptyAndHideResultList();
        };

        return {
            init: ($container) => {
                if ($container.length === 0) {
                    return
                }

                _cacheDOM($container);

                _cacheData();

                _bindEvents();
            },
            focusSearchField: _focusSearchField,
            clear: _clear
        };
    }
})();

module.exports = window.app.core.factorify(_search);
